import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ButtonCircle from "../../../shared/components/button_circle";
import { WrapMain } from "../../../shared/modules/wrap_main";
import { useDispatch } from "../../../stateManagement/redux";
import {
    downloadFileReport,
    getDataForAnalyst,
} from "../../../stateManagement/redux/slices/gerencia_tecnica/asyncReducers";
import "../../../styles/globalstyles.scss";
import Dashboards from "./reports";
import "./styles.scss";
// import { ModalAnalyst } from '../../../modules/modal_analyst';
// import { ListOfLocationsToAnalyst } from "src/stateManagement/redux/slices/gerencia_tecnica/interfaces";
import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Tab,
    Tabs, Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useParams } from "react-router-dom";
import { projectList } from "../../../shared/util/projectList";
import { ListOfLocationsToAnalyst } from "../../../stateManagement/redux/slices/gerencia_tecnica/interfaces";
import { ModalAnalyst } from "../../modules/modal_analyst";
import ListLocation from "./listLocation";
import Planning from "./planing";
import { ActivityAnalyzer } from "./optimizationOptions";
import { AgileView } from "./operations";
import BarChartIcon from "@mui/icons-material/BarChart";


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{}}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const ModalReports = ({
    startDate,
    endDate,
    onClose,
}: {
    startDate: string;
    endDate: string;
    onClose: () => void;
}) => {
    const dispatch = useDispatch();

    const downloadFieldReportOnClick = () => {
        dispatch(downloadFileReport(startDate, endDate));
        onClose();
    };

    const getDataForDashboard = () => {
        dispatch(getDataForAnalyst(startDate, endDate));
        onClose();
    };

    const reportsOptionsList = [
        {
            name: "Descargar Reporte unificado de Campo",
            onclick: downloadFieldReportOnClick,
        },
        { name: "Consultar Data para Dashboard", onclick: getDataForDashboard },
    ];

    return (
        <div className="download_report_modal_container">
            <div className="download_report_modal_container_form_container">
                <div className="download_report_modal_container_form_container_close_section">
                    <ButtonCircle
                        icon="/assets/icons/close.svg"
                        iconHeight={15}
                        iconWidth={15}
                        onClick={onClose}
                    />
                </div>
                <div className="download_report_modal_container_form_container_info_section">
                    <img
                        src="/assets/icons/download.svg"
                        alt=""
                        width={60}
                        height={80}
                    />
                    <div className="download_report_modal_container_form_container_title">
                        Consultas Disponibles
                    </div>
                    <div className="download_report_modal_container_form_container_subtitle">
                        Selecciona una opcion para el periodo del {startDate}{" "}
                        hasta {endDate}
                    </div>
                </div>
                <div className="download_report_modal_container_options_container">
                    {reportsOptionsList?.map((item, index) => (
                        <div
                            key={index}
                            className="download_report_modal_container_options_container_option"
                            onClick={item.onclick}
                        >
                            {item.name}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

const Dashboard = () => {
    const { tabValue } = useParams();
    const [value, setValue] = useState(tabValue ? Number(tabValue) : 0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const tabs = [
        { id: "dashboard", name: "Dashboard" },
        // { id: "analyze", name: "Analisis" },
        { id: "listLocations", name: "Lista de Locaciones" },
    ];

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const [projectId, setProjectId] = useState("");

    const [showModal, setShowModal] = useState(false);

    const [showAnalystModal, setShowAnalystModal] = useState(false);

    const [activeLocationToAnalyst, setActiveLocationToAnalyst] =
        useState<any>(undefined);

    const [activeTab, setActiveTab] = useState("dashboard");

    const showAnalystCardModal = (location: ListOfLocationsToAnalyst) => {
        setActiveLocationToAnalyst(location);
        setShowAnalystModal(true);
    };

    return (
        <>
            {showModal && (
                <ModalReports
                    startDate={startDate.toISOString().split("T")[0]}
                    endDate={endDate.toISOString().split("T")[0]}
                    onClose={() => setShowModal(false)}
                />
            )}
            {showAnalystModal && (
                <ModalAnalyst
                    onClose={() => setShowAnalystModal(false)}
                    location={activeLocationToAnalyst}
                />
            )}
            {/* Filters */}

            <Box sx={{ width: "100%" }}>
                <Grid container spacing={0}>
                    <Grid size={12}>
                        <Box>
                            <Box
                                sx={{
                                    borderBottom: 1,
                                    borderColor: "divider",
                                    position: "sticky",
                                    padding: "10px",
                                    top: 0,
                                    backgroundColor: "white",
                                    zIndex: 1,
                                }}
                            >
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    aria-label="tabs vertical icon-text"
                                    TabIndicatorProps={{
                                        sx: { display: "none" },
                                    }}
                                    sx={{ px: 2 }}
                                >
                                    {[
                                        {
                                            icon: "/assets/icons/report_icon_unselect.svg",
                                            iconSelected:
                                                "/assets/icons/report_icon.svg",
                                            label: "REPORTES",
                                        },
                                        {
                                            icon: "/assets/icons/planification_icon_unselect.svg",
                                            iconSelected:
                                                "/assets/icons/planification_icon.svg",
                                            label: "PLANIFICACIÓN",
                                        },
                                        {
                                            icon: "/assets/icons/location_list_icon_unselect.svg",
                                            iconSelected:
                                                "/assets/icons/location_list_icon.svg",
                                            label: "LISTA DE LOCACIONES",
                                        },
                                        {
                                            icon: "/assets/icons/report_icon_unselect.svg",
                                            iconSelected:
                                                "/assets/icons/report_icon.svg",
                                            label: "POZOS ANALIZADOS",
                                        },
                                        {
                                            icon: "/assets/icons/report_icon_unselect.svg",
                                            iconSelected:
                                                "/assets/icons/report_icon.svg",
                                            label: "BUSQUEDA AGIL",
                                        },
                                    ].map((tab, index) => {
                                        const isWideLabel =
                                            tab.label.length > 16; // Ajusta según el umbral que necesites
                                        return (
                                            <Tab
                                                key={index}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            flexDirection:
                                                                "column",
                                                            alignItems:
                                                                "center",
                                                            justifyContent:
                                                                "center",
                                                            textAlign: "center",
                                                            width: isWideLabel
                                                                ? 150
                                                                : 130, // Más ancho para títulos largos
                                                        }}
                                                    >
                                                        <Box
                                                            component="img"
                                                            src={
                                                                value === index
                                                                    ? tab.iconSelected
                                                                    : tab.icon
                                                            }
                                                            sx={{
                                                                mb: 0.5,
                                                                width: 25,
                                                                height: 25,
                                                            }}
                                                        />
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                fontSize:
                                                                    "0.75rem",

                                                                display:
                                                                    "inline-block",
                                                                maxWidth:
                                                                    "100%",
                                                            }}
                                                        >
                                                            {tab.label}
                                                        </Typography>
                                                    </Box>
                                                }
                                                sx={{
                                                    minWidth: "auto",
                                                    padding: 0,
                                                    borderBottom: "none",
                                                    ml: 1,
                                                    "&.Mui-selected": {
                                                        borderBottom: "none",
                                                        color: "custom.blue2",
                                                        fontWeight: 700,
                                                    },
                                                }}
                                                {...a11yProps(index)}
                                            />
                                        );
                                    })}
                                </Tabs>
                            </Box>

                            <Box sx={{ padding: "20px" }}>
                                <CustomTabPanel value={value} index={0}>
                                    <Dashboards />
                                </CustomTabPanel>
                                <CustomTabPanel value={value} index={1}>
                                    <Planning />
                                </CustomTabPanel>
                                <CustomTabPanel value={value} index={2}>
                                    <ListLocation />
                                </CustomTabPanel>
                                <CustomTabPanel value={value} index={3}>
                                    <ActivityAnalyzer />
                                </CustomTabPanel>
                                <CustomTabPanel value={value} index={4}>
                                    <AgileView />
                                </CustomTabPanel>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

const index = () => {
    return (
        <WrapMain>
            <Dashboard />
        </WrapMain>
    );
};

export default index;
